import { render, staticRenderFns } from "./VoteModal.vue?vue&type=template&id=339f6675&scoped=true&"
import script from "./VoteModal.vue?vue&type=script&lang=js&"
export * from "./VoteModal.vue?vue&type=script&lang=js&"
import style0 from "./VoteModal.vue?vue&type=style&index=0&id=339f6675&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "339f6675",
  null
  
)

export default component.exports